<template>
  <div>
    <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" :title="title" width="500px" @close="resetField">
      <div slot="content">
        <el-form ref="form" :model="filterData" label-position="top" :rules="rules">
          <div v-show="isAdd">
            <el-row>
              <el-col>
                <el-form-item label="로그명" label-width="120px" prop="applogId">
                  <el-select v-model="filterData.applogId" placeholder="로그선택">
                    <el-option v-for="(item, index) in logList" :key="index" :label="item.applogId" :value="item.applogId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="정책 명" label-width="120px" prop="applogFilterId"><el-input @input="typing" placeholder="정책명을 입력하세요" v-model="filterData.applogFilterId"></el-input></el-form-item>
            </el-row>
          </div>
          <el-row>
            <el-form-item label="정책 조건" label-width="120px"><el-input placeholder="정책 조건을 입력하세요" v-model="filterData.filterCondition"></el-input></el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="예외 정책" label-width="120px"><el-input placeholder="예외 조건을 입력하세요" v-model="filterData.exceptFilterCondition"></el-input></el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="large" type="solid" @click="settingApplogFilter">저장</el-button>
        <el-button @click="close" size="large" >취소</el-button>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import LmsApplogAPI from '@/api/settings/log/lms-applog-setting';
import WSettingSlidingPopup from '@/components/popup/SettingSlidingPopup/SettingSlidingPopup';
import { isEmpty, isNil } from 'lodash';
import msgUtil from '@/utils/message';

export default {
  name: 'WAppLogFilterPopup',
  components: {
    WSettingSlidingPopup,
  },
  props: {
    isAdd: {
      type: Boolean,
    },
    formData: {
      type: Object,
      default() {},
    },
    selectPhysicalNode: {
      type: Object,
    },
  },
  watch: {
    formData() {
      if (this.isAdd) {
        this.filterData = {
          applogId: '',
          applogFilterId: null,
          filterCondition: null,
          exceptFilterCondition: null,
        };
      } else {
        this.filterData = this.formData;
      }
    },
    isAdd() {
      this.title = (this.isAdd) ? '로그 정책 추가' : '로그 정책 수정';
    },
    immediate: true,
  },
  data() {
    const validateFilterName = (rule, value, callback) => {
      const pattern = /[ㄱ-ㅎㅏ-ㅣ가-힣\W]/;
      if (isNil(value) || isEmpty(value)) {
        callback(new Error('필수 정보 입니다.'));
      }
      if (pattern.test(value) === true) {
        callback(new Error('정책 명은 영문 입력입니다.'));
      }
      callback();
    };
    return {
      title: '로그 정책 추가',
      filterData: {
        applogId: '',
        applogFilterId: null,
        filterCondition: null,
        exceptFilterCondition: null,
      },
      logList: [],
      rules: {
        applogId: [
          { required: true, message: '필수 정보입니다.', trigger: 'change' },
        ],
        applogFilterId: [
          { required: true, validator: validateFilterName, trigger: 'blur' },
          { min: 1 },
        ],
      },
    };
  },
  methods: {
    /**
     * 필터명 한글 입력 검사
     * @author leesy918
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    typing(data) {
      const message = data;
      const pattern = /([^가-힣\x20])/i;
      this.valid = (message.length > 1 && pattern.test(message) === true);
    },
    /**
     * 로그 필터 추가
     * @author leesy918
     */
    settingApplogFilter() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.isAdd) {
            this.saveApplogFilter();
          } else {
            this.updateApplogFilter();
          }
        }
      }).catch(() => {});
    },
    saveApplogFilter() {
      this.filterData.serverId = this.selectPhysicalNode.serverId; // 서버 아이디 임시 지정
      const logInfo = this.logList.find((item) => item.applogId === this.filterData.applogId);
      this.filterData.logCollectorId = logInfo.logCollectorId;
      this.filterData.logId = logInfo.logId;

      LmsApplogAPI.addApplogFilter(this.filterData).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '정책', true));
          this.$emit('loadData');
          this.close();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '정책', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '정책', false));
        throw new Error(e);
      });
    },
    updateApplogFilter() {
      this.filterData.serverId = this.selectPhysicalNode.serverId; // 서버 아이디 임시 지정
      const logInfo = this.logList.find((item) => item.applogId === this.filterData.applogId);
      this.filterData.logCollectorId = logInfo.logCollectorId;
      this.filterData.logId = logInfo.logId;

      LmsApplogAPI.updateApplogFilter(this.filterData).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '정책', true));
          this.$emit('loadData');
          this.close();
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '정책', false));
        throw new Error(e);
      });
    },
    /**
     * 필터리스트 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      const params = {};
      params.serverId = this.selectPhysicalNode.serverId;
      LmsApplogAPI.getApplogName(params).then((response) => {
        if (response.data.success) {
          // 응답 데이터 처리
          this.logList = response.data.data;
          if (this.isAdd && !isEmpty(this.logList)) {
            this.filterData.applogId = this.logList[0].applogId;
          }
          this.$refs.slidingPopup.visible = true;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필터 목록', false));
        throw new Error(e);
      });
    },
    resetField() {
      this.$refs.form.resetFields();
    },
    open() {
      this.loadData();
    },
    close() {
      this.$refs.form.resetFields();
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Applog/popup/AppLogFilterPopup.vue